import { useTranslation } from 'next-i18next';
import { AddressPin } from '@oresundsbron/icons';
import { ContactInfoLine } from './';

export const AddressLine = ({ address }: { address: string }) => {
  const { t } = useTranslation(['club', 'common'], { nsMode: 'fallback' });

  return (
    <ContactInfoLine>
      <div className="flex items-center">
        <AddressPin stroke="bg-primary-950" />
        <span className="ml-4 hidden sm:inline">
          {t('club.contactInformation.address')}
        </span>
      </div>
      <div className="text-primary-950">{address}</div>
    </ContactInfoLine>
  );
};
